// Translation and extensions move nodes React owns, and its next commit then fails to find them where it
// left them. The wording is Safari's, Chrome's and Firefox's in that order.
export const DOM_MUTATION_ERROR = /The object can not be found here\.|Failed to execute '(removeChild|insertBefore)' on 'Node': The node .+ is not a child of this node|Node\.(removeChild|insertBefore): /;
